import { createContext } from "react";
import { IChat, IChatMessages } from "../../models/chat/response";
import { IChatQuery , IChatMessageQuery } from "../../models/chat/query";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import {
  ICreateChat, IChatMessageRequest
} from "../../models/chat/request";
import { Socket } from "socket.io-client";

export type ChatLoading =
  | "list"
  | "messages"
  | "create"
  | "sendMessage"

export interface IInternalState {
  loading: ChatLoading[];
  list?: IChat[];
  query: IChatQuery;
  messageQuery: IChatMessageQuery;
  light?: IChat[];
  allChats?: IChat[];
  messages?:IChatMessages;
  socket?: Socket; 
  selectedChatId?: number | null;
}

export const internalState: IInternalState = {
  loading: [],
  list:[],
  messageQuery: DEFAULT_QUERY,
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getAllData: () => void;
    getMessages: () => void;
    setMessages: (data?: IChatMessages) => void;
    createChat: (request: ICreateChat) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IChatQuery) => void;
    setMessageQuery: (query: IChatMessageQuery) => void;
    setupSocket: () => void;
    onNewMessage: (callback: (message: any) => void) => void;
    emitMessage: (event: string, payload: any) => void;
    setSelectedChatId: (chatId: number) => void;
    sendMessage: (formData: IChatMessageRequest) => Promise<void>;

  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getAllData: DEFAULT_FUNCTION,
    getMessages: DEFAULT_FUNCTION,
    setMessages: DEFAULT_FUNCTION,
    createChat: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
    setMessageQuery: DEFAULT_FUNCTION,
    setupSocket: DEFAULT_FUNCTION,
    onNewMessage: DEFAULT_FUNCTION,
    emitMessage: DEFAULT_FUNCTION,
    setSelectedChatId: DEFAULT_FUNCTION,
    sendMessage: DEFAULT_FUNCTION,

  },
};

const ChatContext = createContext(externalState);

export default ChatContext;
